import script from "./HistoryBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryBar.vue?vue&type=script&setup=true&lang=js"

import "./HistoryBar.vue?vue&type=style&index=0&id=5a5941c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5941c6"]])

export default __exports__